module.exports = __webpack_public_path__ + "static/media/cancel.b9477734.svg";